export default {
    projects: [
        {
            id: 1, 
            title: "Great Lakes Water Authority",
            slug: "great-lakes-water-authority",
            folder: "great-lakes-water",
            intro: [
                "I was hired by Bridgeport Consulting to create communications that express GLWA’s work to ensure quality water to southeast Michigan.", 
                "GLWA advocates environmentally-friendly waste disposal, and shares the plans underway to ensure clean water and sound water infrastructure for the region. Their target audience includes homeowners, businesses and community leaders.",
                "My role was to convert information from Bridgeport into clear and engaging visuals that support GLWA’s efforts."
            ],
            gallery: [
                { hqi: "1.jpg", lqi: "1-low.jpg" },
                { hqi: "2.svg", lqi: "2.svg" },
                { hqi: "3.jpg", lqi: "3-low.jpg" },
                { hqi: "4.jpg", lqi: "4-low.jpg" },
                { hqi: "5.jpg", lqi: "5-low.jpg" },
                { hqi: "6.svg", lqi: "6.svg" },
                { hqi: "7.jpg", lqi: "7-low.jpg" },
            ]
        },
        {
            id: 2, 
            title: "Ypsilanti Meals on Wheels",
            slug: "ypsilanti-meals-on-wheels",
            folder: "ypsi-meals",
            intro: [
                "Ypsilanti Meals on Wheels’ mission is to deliver meals, pet supplies, personal items, and a daily check-in to the area’s homebound population. YMOW was in their 45th year of service when they hired me to design their new communication pieces.",
                "My goal was to refresh their existing branding and give a warm, human feeling to represent their services. I worked with YMOW staff to create professional, approachable designs that reflect their work in the community."
            ],
            gallery: [
                { hqi: "1.jpg", lqi: "1-low.jpg" },
                { hqi: "2.jpg", lqi: "2-low.jpg" },
                { hqi: "3.jpg", lqi: "3-low.jpg" },
                { hqi: "4.svg", lqi: "4.svg" },
                { hqi: "5.jpg", lqi: "5-low.jpg" },
                { hqi: "6.jpg", lqi: "6-low.jpg" }
            ]
        },
        {
            id: 3, 
            title: "Simpson Garden Park",
            slug: "simpson-garden-park",
            folder: "simpson-garden",
            intro: [
                "Simpson Garden Park is an 11-acre garden that is part of the parks services of Bowling Green, Ohio. It is tucked into a residential area, and is a hidden gem. I was hired to design a series of newsletters to highlight the garden’s many attractions. Gardening education, as well as support and volunteer opportunities, were also featured." 
            ],
            gallery: [
                { hqi: "1.jpg", lqi: "1-low.jpg" },
                { hqi: "2.jpg", lqi: "2-low.jpg" },
                { hqi: "3.jpg", lqi: "3-low.jpg" },
                { hqi: "4.jpg", lqi: "4-low.jpg" }
            ]
        },
        {
            id: 4, 
            title: "Torrance Refining Company",
            slug: "torrance-refining-company",
            folder: "torrance-refining",
            intro: [
                "I have worked with the Torrance Refinery since 2017, and we have collaborated successfully from three time zones apart. The message of our work has been their role in providing a reliable supply of fuels while being a fair employer and good neighbor.",
                "The refinery has hosted three major community events for which I produced banners, posters, invitations, and many related pieces. This involved coordinating with printers and suppliers in the Torrance area, and keeping on schedule. In 2017, I designed 60 posters and banners for their neighborhood open house. In 2018, I designed 36 items for that year’s event. In 2019, the refinery celebrated its 90th anniversary with a community-wide picnic for which I designed 40 posters and centerpiece items." 
            ],
            gallery: [
                { hqi: "1.jpg", lqi: "1-low.jpg" },
                { hqi: "2.jpg", lqi: "2-low.jpg" },
                { hqi: "3.jpg", lqi: "3-low.jpg" },
                { hqi: "4.jpg", lqi: "4-low.jpg" }
            ]
        },
        {
            id: 5, 
            title: "Logo Design",
            slug: "logo-design",
            folder: "logos",
            intro: [
                "It is a privilege to develop an identity for a business venture, or to create an icon for a new initiative. I believe listening and understanding the client’s goal and intent is the first step in the creative process. I enjoyed working with each of these groups to create their logos."
            ],
            gallery: [
                { hqi: "1.jpg", lqi: "1-low.jpg" },
                { hqi: "2.jpg", lqi: "2-low.jpg" },
                { hqi: "3.jpg", lqi: "3-low.jpg" },
                { hqi: "4.svg", lqi: "4.svg" },
                { hqi: "5.jpg", lqi: "5-low.jpg" },
                { hqi: "6.jpg", lqi: "6-low.jpg" },
                { hqi: "7.jpg", lqi: "7-low.jpg" },
                { hqi: "8.jpg", lqi: "8-low.jpg" },
                { hqi: "9.jpg", lqi: "9-low.jpg" },
                { hqi: "10.jpg", lqi: "10-low.jpg" },
                { hqi: "11.jpg", lqi: "11-low.jpg" },
                { hqi: "12.jpg", lqi: "12-low.jpg" },
                { hqi: "13.jpg", lqi: "13-low.jpg" },
            ]
        },
        {
            id: 6, 
            title: "Toledo Refining Company",
            slug: "toledo-refining-company",
            folder: "toledo-refining",
            intro: [
                "Toledo Refining Company has a 125-year history as a top employer in northwest Ohio. I have been privileged to work with them in designing their employee communications. The topics covered have ranged from upgrades to the physical plant, refinery history, and family-friendly events."
            ],
            gallery: [
                { hqi: "1.png", lqi: "1-low.png" },
                { hqi: "2.png", lqi: "2-low.png" },
                { hqi: "3.jpg", lqi: "3-low.jpg" },
                { hqi: "4.jpg", lqi: "4-low.jpg" },
            ]
        },
        {
            id: 7, 
            title: "ProMedica",
            slug: "pro-medica",
            folder: "promedica",
            intro: [
                "ProMedica is a non-profit health organization centered in northwest Ohio. Mission Partners is ProMedica’s program that enables area businesses to contribute to health and well-being initiatives in the region.",
                "I have worked with Mission Partners by designing print and online communications for their supporters in the business community. Our purpose has been to foster awareness, financial assistance, and participation."
            ],
            gallery: [
                { hqi: "1.jpg", lqi: "1-low.jpg" },
                { hqi: "2.jpg", lqi: "2-low.jpg" }
            ]
        },
        {
            id: 8, 
            title: "Zimm's Central Vacuum",
            slug: "zimms-central-vacuum",
            folder: "zimms-vac",
            intro: [
                "I was hired by Zimm’s to revamp the company’s existing website. With the help of a web developer, the site was made more concise, easy to use, and modern. I rewrote the text to be briefer, while keeping all of the information necessary for customers to make a buying decision. The design was reworked to reflect Zimm’s existing brand affiliations while presenting a clean, inviting style."
            ],
            gallery: [
                { hqi: "1.jpg", lqi: "1-low.jpg" },
                { hqi: "2.svg", lqi: "2.svg" },
                { hqi: "3.jpg", lqi: "3-low.jpg" },
                { hqi: "4.jpg", lqi: "4-low.jpg" }
            ],
            url: {
                text: "www.zimmscentralvac.com",
                destination: "https://www.zimmscentralvac.com"
            }
        },
        {
            id: 9, 
            title: "Toledo Symphony Orchestra",
            slug: "toledo-symphony-orchestra",
            folder: "toledo-symphony",
            intro: [
                "I had the honor of working with the Toledo Symphony Orchestra to design the graphics for their premier event of the year.  Invitations, programs and signage were produced for an event that combined an evening of live music with coordinating food and drink."
            ],
            gallery: [
                { hqi: "1.jpg", lqi: "1-low.jpg" },
                { hqi: "2.jpg", lqi: "2-low.jpg" },
                { hqi: "3.jpg", lqi: "3-low.jpg" }
            ]
        },
        {
            id: 10, 
            title: "American Thyroid Association",
            slug: "american-thyroid-association",
            folder: "american-thyroid",
            intro: [
                "The American Thyroid Association hired me to design their Case for Support to increase awareness of their valuable work. The goals of the piece were to highlight their work to date, and to appeal for support for their ongoing work. I made use of infographics to quickly and clearly convey their message."
            ],
            gallery: [
                { hqi: "1.jpg", lqi: "1-low.jpg" },
                { hqi: "2.jpg", lqi: "2-low.jpg" },
                { hqi: "3.jpg", lqi: "3-low.jpg" },
                { hqi: "4.jpg", lqi: "4-low.jpg" }
            ]
        },
        {
            id: 11, 
            title: "Sylvania Schools",
            slug: "sylvania-schools",
            folder: "sylvania-schools",
            intro: [
                "Sylvania Schools hired me to design communications to build awareness, advocacy, and involvement with the school system. We collaborated to create pieces that share information, encourage support, and celebrate accomplishments of students and staff."
            ],
            gallery: [
                { hqi: "1.jpg", lqi: "1-low.jpg" },
                { hqi: "2.jpg", lqi: "2-low.jpg" }
            ]
        },
        {
            id: 12, 
            title: "Lake Electronics Group",
            slug: "lake-electronics-group",
            folder: "lake-electronics",
            intro: [
                "I worked with a web developer and the owner of Lake Electronics Group to create new branding for the company. Lake wanted an updated image, but had an existing brand identity that they did not want to completely break with.",
                "With input from the owners, I designed a new logo and visual identity that drove the look of their printed items, vehicles and website. I also rewrote the text for the new website, making it more concise and user-friendly."
            ],
            gallery: [
                { hqi: "1.jpg", lqi: "1-low.jpg" },
                { hqi: "2.svg", lqi: "2.svg" },
                { hqi: "3.jpg", lqi: "3-low.jpg" },
                { hqi: "4.jpg", lqi: "4-low.jpg" }
            ],
            url: {
                text: "www.lakeelectronicsgroup.com",
                destination: "https://www.lakeelectronicsgroup.com"
            }
        }
    ],
    about: {
        kay: {
            header: "Kay Toon",
            info: [
                "My skill is to use design tools to compose information into an end product that is clear, concise, and most of all - a pleasure to view.",
                "Groups I have worked with range from human services, the arts, and industry, to family businesses. I am always eager to learn about a new endeavor and to partner with clients to tell their story and help reach their goals."
            ]
        },
        website: {
            header: "About This Website",
            info: [
                "I designed and created this site using Sketch and Zeplin software. The designs featured in the portfolio section were created in Adobe PhotoShop, InDesign and Illustrator. I wrote the text to tell my own story. The development for this site, and the portfolio sites, was skillfully done by "
            ]
        },
        portrait: "portrait.jpg",
        portraitMobile: "portrait-mobile.jpg",
        quote: "quote.svg"
    }
};
